module.exports = __webpack_public_path__ + "img/DE00775.0614dc2f.png";